/** @format */

import { Method } from 'axios';
import { TransferStateRequestType } from '../enums/transfer-state-request-type.enum';

/**
 * @description
 * Interface describing what an @angular TransferState configuration looks like. This is used
 * to build a hook to evaluate a valid BasePage Request to see if an HTTP Request should be
 * made for JSON data and inject it into the DOM using @angular TransferState syntax that occurs
 * within an @angular / @nguniversal application using the rendering engine.
 *
 * NOTE: basePageRequest.keyType is used to determine if TransferState should look for a path parameter
 * or query string parameter to trigger off. If value is "path", then a value for basePageRequest.pathParamToUse
 * should be set; if value is "query", then a value for basePageRequest.queryParamToUse should be set
 *
 * NOTE: proxyRequest.pathParamsToForwardAsQueryParams will convert any path parameters specified as
 * query parameters on the HTTP Request for JSON. Specify the path parameter from the path pattern and
 * the name of the query string parameter to use.
 *
 * NOTE: proxyRequest.pathPattern should not start with a leading forward slash ("/") if the serverProxyTarget
 * ends with a forward slash, otherwise you will end up with double forward slashes in the composed URL path
 *
 * NOTE: proxyRequest.serverProxyTarget needs to be one of the keys in the environment.server.proxies object
 *
 * NOTE: proxyRequest.responseDataProperty *can* be nested using dot notation, e.g. "data.title" given
 * the Response object has a property data which also has a property title. If the nested property does not exist,
 * then the default Response object will be used.
 *
 * NOTE: All fields are case-sensitive
 * TODO -- Support POST for fetching data
 */
export interface TransferState {
  basePageRequest: {
    keyType: 'path' | 'query';
    pathParamToUse?: string;
    pathParamsToForward?: string[];
    pathParamsToForwardAsQueryParams?: { pathParam: string; queryParam: string }[];
    queryParamToUse?: string;
    queryParamsToForward?: string[];
  };
  dataKeyName: {
    pathParamToUse?: string;
    prefix: string;
    queryParamsToUse?: string[];
  };
  dataRequest: {
    knownQueryParamsToForward?: {
      [key: string]: string;
    };
    method: Method;
    pathPattern: string;
    remoteTarget?: {
      [key: string]: string;
    };
    responseDataProperty?: string;
    serverProxyTarget?: string;
    targetType: TransferStateRequestType;
  };
  serverStateName: string;
}
